export const mobileWidth = 499;

export const projectInformation = {
	phase: "beta",
	name: "NICE Consultations",
};
